import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import TextArea from "antd/lib/input/TextArea";
import { radioStyle } from "./styles";
import { Form, Input, Radio, Row, Col } from "antd";

class SignUpForm1 extends React.Component {
  state = {
    otherLegalStatus: this.props.initialFormData.legal_status_other || "",
    otherBusinessType: this.props.initialFormData.business_type_other || "",
  };

  handleLegalStatusChange = (e) => {
    this.props.form.setFieldsValue({ legal_status_other: "" });
    this.props.form.validateFields(["legal_status"], { force: true });
  };

  handleOtherValueChange = (e) => {
    this.setState({ otherLegalStatus: e.target.value });
    this.props.form.setFieldsValue({ legal_status: e.target.value });
  };

  handleBusinessTypeChange = (e) => {
    this.props.form.setFieldsValue({ business_type_other: "" });
    this.props.form.validateFields(["business_type"], { force: true });
  };

  handleOtherBusinessTypeChange = (e) => {
    this.setState({ otherBusinessType: e.target.value });
    this.props.form.setFieldsValue({ business_type: e.target.value });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { initialFormData } = this.props; // Access initialFormData from props

    const labelStyle = {
      fontWeight: "800",
      fontSize: "16px",
      whiteSpace: "normal",
      textAlign: "left",
      display: "inline-block",
    };
    const { otherLegalStatus, otherBusinessType } = this.state;

    return (
      <div>
        <Row>
          <Form.Item
            label={
              <span style={labelStyle}>
                What mode of transport do you use ?
              </span>
            }
            colon={false}
          >
            {getFieldDecorator("mode", {
              initialValue: initialFormData.mode,
              rules: [
                {
                  required: true,
                  message: "Please input mode",
                },
              ],
            })(
              <Radio.Group
                name="mode"
                onChange={this.handleChange}
                style={radioStyle}
              >
                <Radio value={"sea"}>Ocean</Radio>
                <Radio value={"air"}>Air</Radio>
                <Radio value={"Truck"}>Truck</Radio>
                {/* </Col> */}
              </Radio.Group>
            )}
          </Form.Item>
        </Row>
        <Row>
          <Form.Item label={<span style={labelStyle}>Legal Status</span>}>
            {getFieldDecorator("legal_status", {
              initialValue: initialFormData.legal_status,
              rules: [
                {
                  required: true,
                  message: "Please input legal status",
                },
              ],
            })(
              <Radio.Group
                name="legal_status"
                onChange={this.handleLegalStatusChange}
              >
                <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
                  <Col xs={24} sm={24} md={8}>
                    <Radio value={"sole proprietorship"}>
                      Sole Proprietorship
                    </Radio>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Radio value={"incorporated"}>Incorporated</Radio>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Radio value={"partnership"}>Partnership</Radio>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Radio value={otherLegalStatus}>
                      {getFieldDecorator("legal_status_other", {
                        initialValue: initialFormData.legal_status_other,
                      })(
                        <Input
                          size="large"
                          placeholder="Other"
                          onChange={this.handleOtherValueChange}
                        />
                      )}
                    </Radio>
                  </Col>
                </Row>
              </Radio.Group>
            )}
          </Form.Item>
        </Row>
        <Row>
          <Form.Item label={<span style={labelStyle}>Type of Business</span>}>
            {getFieldDecorator("business_type", {
              //initialValue: "",
              initialValue: initialFormData.business_type,
              rules: [
                {
                  required: true,
                  message: "Please input type of business",
                },
              ],
            })(
              <Radio.Group
                name="business_type"
                onChange={this.handleBusinessTypeChange}
              >
                <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
                  <Col xs={24} sm={24} md={8}>
                    <Radio value={"manufacturer"}>Manufacturer</Radio>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Radio value={"wholesaler"}>Wholesaler</Radio>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Radio value={"trading"}>Trading House</Radio>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Radio value={"contractor"}>Contractor</Radio>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Radio value={"services"}>Services</Radio>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Radio
                      //value={"other"}
                      value={otherBusinessType}
                    >
                      {getFieldDecorator("business_type_other", {
                        initialValue: initialFormData.business_type_other,
                      })(
                        <Input
                          size="large"
                          placeholder="Other"
                          onChange={this.handleOtherBusinessTypeChange}
                        />
                      )}
                    </Radio>
                  </Col>
                </Row>
              </Radio.Group>
            )}
          </Form.Item>
        </Row>
        <Row
          type="flex"
          md={{ justify: "space-between" }}
          xs={{ justify: "center" }}
          sm={{ justify: "center" }}
          gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={
                <span style={labelStyle}>
                  Place of Incorporation / Registration
                </span>
              }
            >
              {getFieldDecorator("place_registration", {
                initialValue: initialFormData.place_registration,
                rules: [
                  {
                    required: false,
                    message: "Please input place of registration!",
                  },
                ],
              })(<Input size="large" />)}
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label={<span style={labelStyle}>Year Established</span>}>
              {getFieldDecorator("year_established", {
                initialValue: initialFormData.year_established,
                rules: [{ required: false, message: "Please input year!" }],
              })(<Input size="large" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={<span style={labelStyle}>Number of Employees</span>}
            >
              {getFieldDecorator("no_of_employees", {
                initialValue: initialFormData.no_of_employees,
                rules: [
                  {
                    required: false,
                    message: "Please input number of employees!",
                  },
                ],
              })(<Input size="large" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Form.Item label={<span style={labelStyle}>Nature of Business</span>}>
            {getFieldDecorator("nature_of_business", {
              initialValue: initialFormData.nature_of_business,
              rules: [
                {
                  required: false,
                  message: "Please input about your business!",
                },
              ],
            })(<TextArea rows={4} />)}
          </Form.Item>
        </Row>
        <Row>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={<span style={labelStyle}>Ownership/Parent Company</span>}
            >
              {getFieldDecorator("parent_company", {
                initialValue: initialFormData.parent_company,
                rules: [
                  { required: false, message: "Please input parent company!" },
                ],
              })(<Input size="large" />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Form.Item
            label={
              <span style={labelStyle}>
                How many shipments per year your company process?
              </span>
            }
            colon={false}
          >
            {getFieldDecorator("no_of_shipments", {
              initialValue: initialFormData.no_of_shipments,
              rules: [{ required: true, message: "Required" }],
            })(<Input size="large" placeholder="Number of shipments" />)}
          </Form.Item>
        </Row>
      </div>
    );
  }
}

const WrappedSignUpForm1 = Form.create({ name: "signupForm1" })(SignUpForm1);

SignUpForm1.propTypes = {
  queryParams: PropTypes.object,
  final_search_form: PropTypes.object,
};
const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    // booking:state.code_config.booking,
    final_search_form: state.route.final_search_form,
  };
};

export default withRouter(
  connect(mapStateToProps, actions)(WrappedSignUpForm1)
);
